import TravelService from "../services/travel.service"

export const IS_LOGGED_IN = 'isLoggedIn';
export const SET_LOGGED_IN = 'setLoggedIn';

export const FETCH_SAVED_TRAVELERS = 'getSavedTravelers';
export const SET_SAVED_TRAVELERS = 'setSavedTravelers';
export const ADD_TRAVELER = 'addTraveler';
export const REMOVE_TRAVELER = 'removeTraveler';
export const SAVE_TRAVELERS = 'saveTravelers';
export const SET_TRAVELERS = 'setTravelers';

export const FETCH_CITIES = 'fetchCities';
export const SET_CITIES = 'setCities';

export const FETCH_COUNTIES = 'fetchCounties';
export const SET_COUNTIES = 'setCounties';

export const FETCH_COLLECTOR = 'fetchCollector';
export const SET_COLLECTOR = 'setCollector';

export const INIT_QUOTATIONS = 'initQuotations';
export const FETCH_QUOTATIONS = 'fetchQuotations';
export const FETCH_QUOTATION = 'fetchQuotation';
export const SET_QUOTATION = 'setQuotation';
export const SET_SELECTED_QUOTATION = 'setSelectedQuotation';
export const ORDER = 'order';
export const SET_ORDER_DATA = 'setOrderData';

export const REGISTER = 'register';
export const LOGIN = 'login';
export const FORGOT_PASSWORD = 'forgotPassword';

export const FETCH_PROVIDERS = 'fetchProviders';
export const SET_PROVIDERS = 'setProviders';

export const NEXT_STEP = 'nextStep';
export const PREV_STEP = 'prevStep';

export const FETCH_EUROINS_BRANDS = 'fetchEuroinsBrands';
export const SET_EUROINS_BRANDS = 'setEuroinsBrands';

export const SET_SAVE_DATA = 'setSaveData';

export const COLLECT = 'collect';

const state = {
    loggedIn: false,
    travelStep: 1,
    travelers: [{
        firstName: '',
        lastName: '',
        cnp: '',
        amount_insured_id: 2,
        idType: 'CI',
        idSeries: '',
        idNumber: '',
        county: '',
        city: '',
        cityName: '',
        street: '',
        number: '',
        building: '',
        entry: '',
        floor: '',
        apartment: '',
        email: '',
        phone: '',
        registrationNumber: '',
        vin: '',
        selectedTraveler: null,
        selectedQuotation: null,
        coverages: {accident: false, baggage: false, rca: false, roadAssist: false, storno: false, sports: false},
        cities: []
    }],
    savedTravelers: [],
    collector: {},
    providers: [],
    counties: [],
    euroinsBrands: [],
    saveData: false,
    orderData: {
        payment_url: null,
        env_key: null,
        data: null
    },
    amount_insured : {
        1 : '10.000 EURO',
        2 : '30.000 EURO',
        3 : '50.000 EURO'
    }
}

const getters = {
    travelStep(state) {
        return state.travelStep;
    },
    travelers(state) {
        return state.travelers;
    },
    savedTravelers(state) {
        return state.savedTravelers;
    },
    collector(state) {
        return state.collector;
    },
    isLoggedIn(state) {
        return state.loggedIn;
    },
    providers(state) {
        return state.providers;
    },
    quotations(state) {
        return state.quotations;
    },
    counties(state) {
        return state.counties;
    },
    saveData(state) {
        return state.saveData;
    },
    orderData(state) {
        return state.orderData;
    },
    euroinsBrands(state) {
        return state.euroinsBrands;
    },
    amountInsured(state) {
        return state.amount_insured;
    }
}

const mutations = {
    [ADD_TRAVELER](state, amount_insured_id) {
        state.travelers.push({
            firstName: '',
            lastName: '',
            cnp: '',
            amount_insured_id: amount_insured_id,
            idType: 'CI',
            idSeries: '',
            idNumber: '',
            county: '',
            city: '',
            cityName: '',
            street: '',
            number: '',
            building: '',
            entry: '',
            floor: '',
            apartment: '',
            email: '',
            phone: '',
            registrationNumber: '',
            vin: '',
            selectedTraveler: null,
            selectedQuotation: null,
            coverages: {accident: false, baggage: false, rca: false, roadAssist: false, storno: false, sports: false}
        })
    },
    [REMOVE_TRAVELER](state, idx) {
        state.travelers.splice(idx, 1)
    },
    [SET_SAVED_TRAVELERS](state, savedTravelers) {
        state.savedTravelers = savedTravelers
    },
    [SET_TRAVELERS](state, travelers) {
        state.travelers = travelers;
    },
    [NEXT_STEP](state) {
        if (state.travelStep < 4) state.travelStep++
    },
    [PREV_STEP](state) {
        if (state.travelStep > 1) state.travelStep--;
    },
    [SET_LOGGED_IN](state, loggedIn) {
        state.loggedIn = loggedIn;
    },
    [SET_COLLECTOR](state, collector) {
        state.collector = collector;
    },
    [SET_PROVIDERS](state, providers) {
        state.providers = providers
    },
    [SET_QUOTATION](state, {idx, provider, quotation}) {
        let traveler = state.travelers[idx];
        traveler.quotations[provider] = quotation;
        traveler.quotations[provider].loading = false;

        state.travelers.splice(idx, 1, traveler);
    },
    [INIT_QUOTATIONS](state, providers) {
        TravelService.initQuotations();
        for (let idx in state.travelers) {
            let t = state.travelers[idx];
            t.quotations = {};
            for (let provider of providers) {
                t.quotations[provider] = {
                    loading: true,
                    logo: '/assets/ic/img_logo_' + provider + '.png'
                }
            }

            state.travelers.splice(parseInt(idx), 1, t);
        }
    },
    [SET_SELECTED_QUOTATION](state, {index, quotation}) {
        let traveler = state.travelers[index];
        traveler.selectedQuotation = quotation;
        state.travelers.splice(index, 1, traveler);
    },
    [SET_COUNTIES](state, counties) {
        state.counties = counties;
    },
    [SET_CITIES](state, {index, cities}) {
        let sortableCities = [];
        let traveler = state.travelers[index];
        let found = false;

        for (let key in cities) {
            sortableCities.push([key, cities[key]]);

            if(key === traveler.city) {
                found = true;
            }
        }

        if (!found) {
            traveler.city = '';
            traveler.cityName = '';
        }

        sortableCities.sort((a, b) => {
            return a[1].localeCompare(b[1])
        });

        traveler.cities = sortableCities;
        state.travelers.splice(index, 1, traveler);
    },
    [SET_ORDER_DATA](state, orderData) {
        state.orderData = orderData;
    },
    [SET_EUROINS_BRANDS](state, brands) {
        state.euroinsBrands = brands;
    },
    [SET_SAVE_DATA](state, saveData) {
        state.saveData = saveData;
    }
}

const actions = {
    [FETCH_SAVED_TRAVELERS](context) {
        TravelService.getSavedTravelers()
            .then(({data}) => {
                context.commit(SET_SAVED_TRAVELERS, data);
            })
            .catch(err => console.log(err))
    },
    [SAVE_TRAVELERS](context, travelers) {
        console.log(travelers);
        let travelersToSave = travelers.map(t => {
            delete t.cities;
            delete t.quotations;
            return t
        });

        TravelService.saveTravelers(travelersToSave)
            .then(({data}) => {
                context.commit(SET_SAVED_TRAVELERS, data);
            })
            .catch(err => console.log(err))
    },
    [FETCH_COLLECTOR](context) {
        TravelService.fetchCollector()
            .then(({data}) => {
                context.commit(SET_COLLECTOR, data.collector);
            })
            .catch(err => console.log(err))
    },
    [IS_LOGGED_IN](context) {
        TravelService.isLoggedIn()
            .then((response) => {
                console.log(response)
                context.commit(SET_LOGGED_IN, response.data);
            })
            .catch(err => console.log(err))
    },
    [FETCH_PROVIDERS](context) {
        return new Promise((resolve, reject) => {
            TravelService.fetchProviders()
                .then(({data}) => {
                    context.commit(SET_PROVIDERS, data);
                    resolve(data);
                })
                .catch(err => reject(err))
        })
    },
    [FETCH_QUOTATIONS](context, {travelers, providers}) {
        for (let idx in travelers) {
            for (let provider of providers) {
                context.dispatch(FETCH_QUOTATION, {traveler: travelers[idx], provider: provider})
                    .then(response => {
                        if (response.data.error) console.log(response.data.provider, response.data.error);
                        context.commit(SET_QUOTATION, {idx: idx, provider: provider, quotation: response.data});
                    })
                    .catch(err => {
                        console.log(err);
                        context.commit(SET_QUOTATION, {idx: idx, provider: provider, quotation: {error: err}})
                    })
            }
        }
    },
    [FETCH_QUOTATION](context, {traveler, provider}) {
        let data = {
            ...context.state.collector,
            traveler: {firstName: '', lastName: '', cnp: '', registrationNumber: '', vin: ''}
        };

        data.coverages = Object.assign({}, traveler.coverages);

        data.provider = provider;
        data.traveler.firstName = traveler.firstName;
        data.traveler.lastName = traveler.lastName;
        data.traveler.cnp = traveler.cnp;
        data.traveler.amount_insured_id = traveler.amount_insured_id;
        data.traveler.city = traveler.city;
        data.traveler.street = traveler.street;
        data.traveler.number = traveler.number;
        data.traveler.building = traveler.building;
        data.traveler.floor = traveler.floor;
        data.traveler.entry = traveler.entry;
        data.traveler.apartment = traveler.apartment;
        data.traveler.email = traveler.email;
        data.traveler.phone = traveler.phone;

        if (data.coverages.roadAssist || data.transport === 'Masina' || data.transport ==='Avion+Masina inchiriata') {
            data.traveler.registrationNumber = traveler.registrationNumber;
        }
        if (data.coverages.roadAssist) {
            data.traveler.registrationNumber = traveler.registrationNumber;
            data.traveler.vin = traveler.vin;
        }

        return TravelService.fetchQuotation(data);
    },
    [FETCH_COUNTIES](context) {
        TravelService.fetchCounties()
            .then(({data}) => {
                context.commit(SET_COUNTIES, data);
            })
            .catch(err => console.log(err));
    },
    [FETCH_CITIES](context, {index, countyId}) {
        TravelService.fetchCities(countyId)
            .then(({data}) => {
                context.commit(SET_CITIES, {index: index, cities: data});
            })
            .catch(err => console.log(err));
    },
    [FETCH_EUROINS_BRANDS](context) {
        TravelService.fetchEuroinsBrands()
            .then(({data}) => {
                context.commit(SET_EUROINS_BRANDS, data)
            })
            .catch(err => console.log(err));
    },
    [REGISTER](context, email) {
        return new Promise((resolve, reject) => {
            TravelService.register(email)
                .then(response => {
                    if(response.data.error)
                        reject(response.data.error);

                    context.commit(SET_LOGGED_IN, true);
                    resolve(response);
                })
                .catch(err => {
                    reject(err)
                });
        })
    },
    [LOGIN](context, data) {
        return new Promise((resolve, reject) => {
            TravelService.login(data)
                .then(response => {
                    if(response.data.error)
                        reject(response.data.error);

                    context.commit(SET_LOGGED_IN, true);
                    resolve(response);
                })
                .catch(err => {
                    reject(err)
                });
        })
    },
    [FORGOT_PASSWORD](context, data) {
        return new Promise((resolve, reject) => {
            TravelService.forgot_password(data)
                .then(response => {
                    if(response.data.error)
                        reject(response.data.error);

                    resolve(response);
                })
                .catch(err => {
                    reject(err)
                });
        })
    },
    [ORDER](context, {travelers}) {
        return new Promise(async (resolve, reject) => {

            let quotationPromises = [];
            for (let traveler of travelers) {
                let selectedQuotation = traveler.selectedQuotation;

                quotationPromises.push(context.dispatch(FETCH_QUOTATION, {
                    traveler: traveler,
                    provider: selectedQuotation.provider
                }));
            }

            Promise.all(quotationPromises)
                .then(results => {
                    for (let i in results) {
                        console.log(results[i]);
                        travelers[i].selectedQuotation = results[i].data;

                        let data = {
                            travelers: travelers.map(t => {
                                delete t.cities;
                                delete t.quotations;
                                return t
                            }),
                            ...context.state.collector
                        }

                        TravelService.order(data)
                            .then(({data}) => {
                                context.commit(SET_ORDER_DATA, data.orderData);
                                resolve(data.orderData);
                            })
                            .catch(err => reject(err));
                    }
                })
                .catch(err => console.log(err));
        })

    },

    [COLLECT](context, data) {
        return new Promise((resolve, reject) => {
            TravelService.collect(data)
                .then(response => {
                    resolve(response);
                })
                .catch(err => reject(err))
        })
    }
}


export default {
    state,
    actions,
    getters,
    mutations
}
